import EmployeeBenefits from './EmployeeBenefits';

export default class FilteredEmployeeBenefits {
    benefits: Array<EmployeeBenefits>;
    
    annualBenefitTotal: number = 0;
    annualCompanyBenefitTotal: number = 0;
    annualEmployeeBenefitTotal: number = 0;
    periodBenefitTotal: number = 0;
    periodCompanyBenefitTotal: number = 0;
    periodEmployeeBenefitTotal: number = 0;
    dayBenefitTotal: number = 0;
    dayCompanyBenefitTotal: number = 0;
    dayEmployeeBenefitTotal: number = 0;

    annualBenefitTotalWithoutPto: number = 0;
    annualCompanyBenefitTotalWithoutPto: number = 0;
    annualEmployeeBenefitTotalWithoutPto: number = 0;
    periodBenefitTotalWithoutPto: number = 0;
    periodCompanyBenefitTotalWithoutPto: number = 0;
    periodEmployeeBenefitTotalWithoutPto: number = 0;
    dayBenefitTotalWithoutPto: number = 0;
    dayCompanyBenefitTotalWithoutPto: number = 0;
    dayEmployeeBenefitTotalWithoutPto: number = 0;

    annualPayTotal: number = 0;
    annualCompanyPayTotal: number = 0;
    annualEmployeePayTotal: number = 0;
    periodPayTotal: number = 0;
    periodCompanyPayTotal: number = 0;
    periodEmployeePayTotal: number = 0;
    dayPayTotal: number = 0;
    dayCompanyPayTotal: number = 0;
    dayEmployeePayTotal: number = 0;

    annualPayAndBenefitTotal: number = 0;
    annualCompanyPayAndBenefitTotal: number = 0;
    annualEmployeePayAndBenefitTotal: number = 0;
    periodPayAndBenefitTotal: number = 0;
    periodCompanyPayAndBenefitTotal: number = 0;
    periodEmployeePayAndBenefitTotal: number = 0;
    dayPayAndBenefitTotal: number = 0;
    dayCompanyPayAndBenefitTotal: number = 0;
    dayEmployeePayAndBenefitTotal: number = 0;
}


// WEBPACK FOOTER //
// ./src/models/personnel/FilteredEmployeeBenefits.ts